import React, { Component } from "react";
import firebase from "@firebase/app";
import "@firebase/firestore";

class ExportList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      seasons: null,
      error: null,
    };
  }

  componentDidMount() {
    const firestore = firebase.firestore();
    const seasonsRef = firestore.collection("seasons");

    let seasons = [];

    seasonsRef
      .get()
      .then((docs) => {
        docs.forEach((doc) => {
          seasons.push({
            id: doc.id,
            ...doc.data(),
          });
        });

        this.setState({ seasons });
      })
      .catch((error) => {
        this.setState({ error });
      });
  }

  render() {
    const { seasons, error } = this.state;

    if (!seasons) {
      return <p>Loading...</p>;
    }

    if (error) {
      return <p>ERROR: {error}</p>;
    }

    if (!seasons.length) {
      return <p>No seasons to show</p>;
    }

    return (
      <div className="export-list">
        <h1>Seasons</h1>
        <ul>
          {seasons.map((season) => (
            <li key={season.id}>
              <a href={`/export/${season.id}`}>{season.id}</a>
            </li>
          ))}
        </ul>
      </div>
    );
  }
}

export default ExportList;



// WEBPACK FOOTER //
// ./src/pages/export/list/list.js